import './BookingCalendar.scss'
import { __ } from '@wordpress/i18n'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { IBookingCalendarProps } from './types'
import { Value } from 'react-calendar/dist/esm/shared/types.js'
import { Indication } from './Indication'
import { useWording } from '../../hooks/useWording'
import { useLocale } from '../../hooks/useLocale'

export const BookingCalendar = ({
    availableDates,
    selectedDate,
    setValue,
    setMonth,
}: IBookingCalendarProps) => {
    const wording = useWording()
    const { locale } = useLocale()

    return (
        <div className={'wbk_booking_calendar'}>
            <div className={'wbk_booking_calendar__wrapper'}>
                <Calendar
                    onChange={(value: Value) => setValue(value as Date)}
                    value={selectedDate}
                    tileDisabled={({ date, view }) =>
                        view === 'month'
                            ? availableDates.find(
                                  (d) => d.getTime() === date.getTime()
                              ) === undefined
                            : false
                    }
                    onActiveStartDateChange={({ activeStartDate }) =>
                        setMonth(activeStartDate as Date)
                    }
                    className={'wbk_booking_calendar__calendar-wrapper'}
                    locale={locale || 'en-US'}
                />
            </div>
            <div className={'wbk_booking_calendar__indications'}>
                <Indication
                    label={
                        wording.available ||
                        __('Available', 'webba-booking-lite')
                    }
                    className={'wbk_booking_calendar__indication--available'}
                />
                <Indication
                    label={wording.booked || __('Booked', 'webba-booking-lite')}
                    color="#FFFFFF"
                    borderColor="#D4DDE2"
                />
                <Indication
                    label={wording.today || __('Today', 'webba-booking-lite')}
                    className={'wbk_booking_calendar__indication--today'}
                />
            </div>
        </div>
    )
}
